import React from 'react';

const Usage = () => {
  return (
    <div className="page-container">
      <div className="container">
        <h1>Usage Policy</h1>
        <div className="legal-content">
          <p className="last-updated">Last Updated: April 2025</p>
          
          <h2>1. Scope</h2>
          <p>
            This Usage Policy (“Policy”) applies to all users of InstantResumeAI’s web application at www.instantresumeai.com (“Service”). 
            By accessing or using the Service, you agree to comply with this Policy.
          </p>
          
          <h2>2. Permitted Uses</h2>
          <p>
                Registering for an account, uploading your DOCX resume and a job description, and using our AI enhancement features. <br />
                <br />
 
                Accessing, downloading or printing your enhanced resume for your personal job-search purposes. <br />
                <br />
  
                Contacting Support about Service issues.
          </p>
          
          <h2>3.  Prohibited Conduct</h2>
          <p>
         
                <b> You must not, under any circumstances:</b> <br />
                <br />
                
                Use the Service for any unlawful purpose or in violation of local, national or international laws. <br />
                <br />
                
                Upload or submit content that is defamatory, infringing, obscene, pornographic, harassing, hateful or otherwise objectionable. <br />
                <br />
                Attempt to reverse-engineer, decompile, scrape or bypass any technical safeguards (CAPTCHA, rate limits, authentication) employed by InstantResumeAI. <br />
                <br />
                Share, redistribute or resell enhanced resumes or AI outputs as a competing service or third-party product. <br />
                <br />
                Interfere with or disrupt the integrity or performance of the Service (e.g. denial-of-service attacks). <br />
          </p>
          
          <h2>4. Enforcement</h2>
          <p>
          
                <b>Warnings & Suspension:</b> Violations may result in account warnings or temporary suspension. <br />
                <br />
 
                <b>Termination:</b> Serious or repeated breaches may lead to permanent account termination. <br />
                <br />
 
                <b>Data Removal:</b> InstantResumeAI reserves the right to remove any content that violates this Policy. <br />
                <br />
          </p>
          
         
        </div>
      </div>
    </div>
  );
};

export default Usage;